import React from "react";
import T from "prop-types";
import SendEmailForm from "MODULES/shared/components/SendEmail/Form";
import api from "APP_ROOT/api";

function SendRepairQuoteEmail(props) {
  const { close, lineItem, modal = true } = props;

  return (
    <SendEmailForm
      recordId={lineItem.repair_quote_id}
      url={api.repairQuotes}
      label="Request For Repair Quote"
      close={close}
      modal={modal}
    />
  );
}

SendRepairQuoteEmail.propTypes = {
  close: T.func.isRequired,
  lineItem: T.shape({}),
  modal: T.bool
};

export default SendRepairQuoteEmail;



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/Send/Form.jsx